import { createAction } from "typesafe-actions";

export const Action = {
  open: createAction("/modal/open")<string>(),
  close: createAction("/modal/close")<string>(),
};
